import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledSinglePaletteIconComponent } from "./single-palette-icon-component.scss";
class SinglePaletteIconComponent extends PureComponent {
    render() {
        const { clickableLink, IconComp, title } = this.props;
        return /*#__PURE__*/ _jsx(StyledSinglePaletteIconComponent, {
            className: "social-media-icon",
            children: /*#__PURE__*/ _jsx("a", {
                target: "_blank",
                href: clickableLink,
                title: title,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "regular-icon-container",
                    children: /*#__PURE__*/ _jsx(IconComp, {})
                })
            })
        }, clickableLink);
    }
}
export { SinglePaletteIconComponent as default };
